module.exports = __webpack_public_path__ + "static/media/styledmenu-hamburger_Hover.692b5286.svg";